export default angular.module('eventix.common.directives.shopComponents', [])
    .directive('applyPageClass', function($transitions, $state) {
        return {
            restrict: 'A',
            link: function(scope, el, attr) {
                var orig = attr.class;
                let deregister = $transitions.onSuccess({}, trans => {
                    let toState = trans.to();
                    applyClass(toState.name);
                });
                applyClass($state.current.name);

                function applyClass(stateName) {
                    var className;
                    switch(stateName) {
                        case 'eventix.shop.personalDetails':
                        case 'eventix.shop.summary':
                            className = 'personal-details';
                            break;
                        case 'eventix.shop.tickets':
                        case 'eventix.shop.events':
                        default:
                            className = 'ticket-selection';
                            break;
                    }
                    el.attr('class',[orig,className].join(' '));
                }
                scope.$on('$destroy', deregister);
            }
        };
    })
    .directive('scrollToTop', function($window) {
        return {
            restrict: 'A',
            link: function(scope, el, attr) {
                $window.scrollTop = 0;
                if($window.parentIFrame)
                    $window.parentIFrame.scrollToOffset(0,0);
            }
        };
    })
    .directive('injectCss', function($state) {
        return {
            restrict: 'E',
            link: function(scope, el, attr) {
                let style = scope.$eval(attr.stylesheet);

                if(!_.isEmpty(style) && !$state.params.preview)
                    $(`<style>${style}</style>`).appendTo(document.head);
                $(document.body).removeClass('loading');
            }
        };
    })
    .component('stripeInput', {
        controller: function(StripeSDK, UIMessages, $element) {
            const $ctrl = this;
            $ctrl.info = {
                card: null
            };
            $ctrl.$onInit = function() {
                $ctrl.order.stripe = $ctrl.info;
                $element.addClass('clearfix');
                StripeSDK.get()
                    .then(stripe => {
                        const elements = stripe.elements();
                        $ctrl.info.card = elements.create('card');
                        $ctrl.info.card.mount($element.find('.stripe-input').get(0));
                        $ctrl.info.card.addEventListener('change', event => {
                            $ctrl.order.clearErrors();
                            $ctrl.error = _.get(event, 'error.message', '');
                        });
                    }, error => {
                        UIMessages.push('Unable to load payment solution. Please try again');
                    });
            };
        },
        template: `<form-group label="Credit card info">
    <div class="form-control stripe-input" style="background-color:#f2f2f2; border-radius: 7px; padding-left: 5px; padding-right: 5px;"></div>
    <div class="alert alert-danger" ng-show="vm.error.length">{{vm.error}}</div>
</form-group>`,
        bindings: { order: '<' }
    })
    .component('serviceCostsLine', {
        controller: function($element, $filter) {
            const $ctrl = this;
            $ctrl.translateValues = {};
            $ctrl.serviceCostsIncluded = false;
            $ctrl.$onInit = function() {
                $ctrl.serviceCostsIncluded = _.get(this, 'ticket.include_service_cost_in_price', false);
                $ctrl.varying_costs = $ctrl.ticket.original_price * $ctrl.ticket.service_cost_percentage;

                $ctrl.displayFee = $ctrl.ticket.service_cost + $ctrl.varying_costs;
                $ctrl.displayPrice = $ctrl.ticket.original_price

                $ctrl.translateValues = {
                    'ticket_price' : $filter('formatCurrency')($ctrl.displayPrice, $ctrl.currency, $ctrl.locale),
                    'service_costs': $filter('formatCurrency')($ctrl.displayFee, $ctrl.currency, $ctrl.locale),
                }
            }
        },
        template: `<span translate="{{ $ctrl.serviceCostsIncluded ? 'models.ticket.service_cost_included' : 'models.ticket.service_cost' }} " translate-values="$ctrl.translateValues"></span>`,
        bindings: { ticket: '<', locale: '<', currency: '<' }
    })
    .name;
